import jquery from 'jquery';
import _ from 'underscore';
import { GridStack } from 'gridstack';

let jqueryInstance = null;

function getJQuery() {
  if (jquery.fn) {
    return jquery;
  }
  const currentWindow = globalThis.document?.defaultView || globalThis.window;
  if (!jqueryInstance || jqueryInstance.__askfelixWindow !== currentWindow) {
    jqueryInstance = jquery(currentWindow);
    jqueryInstance.__askfelixWindow = currentWindow;
  }
  return jqueryInstance;
}

function $(...args) {
  return getJQuery()(...args);
}

function getNodeFromEl(el) {
  var node = el.data('_gridstack_node') || (el[0] && el[0].gridstackNode);
  return node;
}

function getGridConfig() {
  var res = _.map($('.grid-stack .grid-stack-item:visible'), function (el) {
    el = $(el);
    var html = el.html();
    var node = getNodeFromEl(el) || {};

    return {
      id: el.attr('gs-id') || el.attr('data-gs-id'),
      x: node.x ?? Number(el.attr('gs-x') || el.attr('data-gs-x') || 0),
      y: node.y ?? Number(el.attr('gs-y') || el.attr('data-gs-y') || 0),
      width: node.w ?? node.width ?? Number(el.attr('gs-w') || el.attr('data-gs-width') || 12),
      height: node.h ?? node.height ?? Number(el.attr('gs-h') || el.attr('data-gs-height') || 6),
      html: html
    };
  });
  return res;
}
function getGridConfigNoHTML() {
  var gridConfig = getGridConfig();
  for (var i = 0; i < gridConfig.length; i++) {
    delete gridConfig[i].html;
  }

  return gridConfig;
}

// var serialization = [
//     {x: 0, y: 0, width: 2, height: 2},
//     {x: 3, y: 1, width: 1, height: 2},
//     {x: 4, y: 1, width: 1, height: 1},
//     {x: 2, y: 3, width: 3, height: 1},
//     {x: 1, y: 4, width: 1, height: 1},
//     {x: 1, y: 3, width: 1, height: 1},
//     {x: 2, y: 4, width: 1, height: 1},
//     {x: 2, y: 5, width: 1, height: 1}
// ];
function loadGridConfig(serialization) {
  // Use GridStack utilities for sorting if available
  if (typeof GridStack !== 'undefined' && GridStack.Utils && GridStack.Utils.sort) {
    serialization = GridStack.Utils.sort(serialization);
  }

  var grid = $('.grid-stack').data('gridstack');
  var parent = $('.grid-stack').parent();

  if (grid) {
    grid.removeAll(true);
    grid.destroy(true);
  }
  parent.empty();
  parent.append('<div class="grid-stack"></div>');
  if (typeof GridStack !== 'undefined') {
    window.griddashboard = GridStack.init(options, '.grid-stack');
  } else {
    console.error('GridStack not available in loadGridConfig');
  }

  _.each(serialization, function (node) {
    addWidgetToGrid(window.griddashboard || grid, node.html, {
      x: node.x,
      y: node.y,
      w: node.width,
      h: node.height,
      autoPosition: true,
      id: node.id
    });
  });
}

function loadGridConfigNoHTML(serialization) {
  // widgets have already been loaded
  // just need to set the x,y,width,height

  // Use GridStack utilities for sorting if available
  if (typeof GridStack !== 'undefined' && GridStack.Utils && GridStack.Utils.sort) {
    serialization = GridStack.Utils.sort(serialization);
  }
  var grid = $('.grid-stack').data('gridstack');
  // var parent = $('.grid-stack').parent();

  var els = $('.grid-stack-item');
  _.each(serialization, function (node) {
    var el = els.filter(`[data-gs-id="${node.id}"]`);
    // var node = getNodeFromEl(el);
    grid.update(el, node.x, node.y, node.width, node.height);
  });
}

function moveGridDown(val) {
  $('data-gs-y').each(function () {
    $(this).attr('data-gs-y', $(this).attr('data-gs-y') + val);
  });
}

function addWidgetToGrid(grid, html, options) {
  if (!grid) {
    return;
  }
  var widget;
  var $html = typeof html === 'string' ? $(`${html}`) : $(html);
  var htmlElement = $html[0] || html;
  var isCompleteGridItem = $html.hasClass('grid-stack-item');
  try {
    if (isCompleteGridItem) {
      widget = grid.addWidget(
        htmlElement,
        options.x,
        options.y,
        options.w || options.width,
        options.h || options.height,
        options.autoPosition,
        null,
        null,
        null,
        null,
        options.id
      );
    } else {
      widget = grid.addWidget(html, options);
    }
  } catch (err) {
    widget = grid.addWidget(
      htmlElement,
      options.x,
      options.y,
      options.w || options.width,
      options.h || options.height,
      options.autoPosition,
      null,
      null,
      null,
      null,
      options.id
    );
  }
  var $widget = $(widget || $html);
  if ($widget.length) {
    $widget.attr({
      'data-gs-x': options.x,
      'data-gs-y': options.y,
      'data-gs-width': options.w || options.width,
      'data-gs-height': options.h || options.height,
      'data-gs-id': options.id
    });
  }
}

function addNewHTMLToGrid(html, height, id) {
  //move everything down the x by 10
  moveGridDown(height);
  // prepend to config
  var grid = window.griddashboard || $('.grid-stack').data('gridstack');
  if (grid) {
    //0,0 is min max min max width
    addWidgetToGrid(grid, html, { x: 0, y: 0, w: 12, h: height, id: id });
  }
}
window.addNewHTMLToGrid = addNewHTMLToGrid;

function removeNodeFromGrid(el) {
  var grid = window.griddashboard || $('.grid-stack').data('gridstack');
  if (grid) {
    grid.removeWidget(el, true);
  }
}
window.removeNodeFromGrid = removeNodeFromGrid;

var options = {
  animate: true,
  verticalMargin: '1em',
  width: 12,
  minRow: 2, // don't let it collapse when empty

  draggable: {
    handle: '.card--header, header',
    scroll: false,
    appendTo: 'body'
  },
  alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  ),
  resizable: {
    handles: 'e, se, s'
  }
  //max height
  // height: 24,
  //resize handler
  //   onResize: function (event, ui) {
  //     console.log('resize');
  //   },
  //   onDragStop: function (event, ui) {
  //     console.log('drag stop');
  // },
};

function initializeGridDashboard() {
  const activeDocument = globalThis.document;
  const activeWindow = globalThis.window;
  // Only initialize GridStack if there's a grid-stack element on the page
  if (!activeDocument?.querySelector('.grid-stack')) {
    if (activeWindow) {
      activeWindow.griddashboard = null;
    }
    return null; // No grid on this page, skip initialization
  }
  // Use modern GridStack API instead of jQuery plugin
  if (typeof GridStack !== 'undefined') {
    window.griddashboard = GridStack.init(options, '.grid-stack');
  } else {
    console.error('GridStack not available. Check library loading order.');
  }
  // {#                let grid = GridStack.init({#}
  // {#cellHeight: 'initial', // start square but will set to % of window width later#}
  // {#animate: true, // show immediate (animate: true is nice for user dragging though)#}
  // {#disableOneColumnMode: true, // will manually do 1 column#}
  // {#float: true });#}

  let layout = 'moveScale';

  // function resizeGrid() {
  //   let width = document.body.clientWidth;u
  //   if (width < 700) {
  //     griddashboard.column(1, layout).cellHeight('100vw');
  //   } else if (width < 850) {
  //     griddashboard.column(3, layout).cellHeight('33.3333vw');
  //   } else if (width < 950) {
  //     griddashboard.column(6, layout).cellHeight('16.6666vw');
  //   } else if (width < 1100) {
  //     griddashboard.column(8, layout).cellHeight('12.25vw');
  //   } else {
  //     griddashboard.column(12, layout).cellHeight('8.3333vw');
  //   }
  // };
  //
  // resizeGrid(); // finally size to actual window
  // window.addEventListener('resize', resizeGrid);
  // trigger resize to set size of plotly graphs inside grid
  //observe width/height changes in .grid-stack-item
  //and resize plotly graphs inside
  function resizeAllPlotlyGraphs() {
    var gd3 = document.getElementsByClassName('js-plotly-plot');
    for (var i = 0; i < gd3.length; i++) {
      var idAttr = gd3[i].getAttribute('id');
      // todo cache this? by parent width/height?
      if (!idAttr) {
        continue;
      }
      Promise.resolve(Plotly.relayout(idAttr, {})).catch(() => {});
    }
  }

  if (typeof ResizeObserver !== 'undefined') {
    var sizes = new WeakMap();
    var resizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var box = entry.target;
        var w = Math.round(entry.contentRect.width);
        var h = Math.round(entry.contentRect.height);
        var prev = sizes.get(box);
        sizes.set(box, w + 'x' + h);
        if (!prev || prev === w + 'x' + h) return;
        var gd = box.querySelector('.js-plotly-plot');
        if (gd && window.Plotly && window.Plotly.Plots) {
          try { Promise.resolve(window.Plotly.Plots.resize(gd)).catch(() => {}); } catch (e) {}
        }
      });
    });
    var observeItems = function () {
      document.querySelectorAll('.grid-stack-item-content').forEach(function (box) {
        if (box.dataset.hxObserved) return;
        box.dataset.hxObserved = '1';
        resizeObserver.observe(box);
      });
    };
    observeItems();
    new MutationObserver(observeItems).observe(activeDocument.body, { childList: true, subtree: true });
  } else {
    setInterval(resizeAllPlotlyGraphs, 2000);
  }

  // Also resize on visibility/orientation/resize events for responsiveness
  function resizeOnEvent() {
    try { resizeAllPlotlyGraphs(); } catch (e) {}
  }
  window.addEventListener('resize', resizeOnEvent);
  window.addEventListener('orientationchange', resizeOnEvent);

  // Responsive grid columns: collapse to 1 column on small screens
  function applyResponsiveGridColumns() {
    if (!window.griddashboard || typeof window.griddashboard.column !== 'function') return;
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    try {
      if (width <= 768) {
        window.griddashboard.column(1);
        // Reduce interaction conflicts on touch: disable dragging/resizing in single column
        try { window.griddashboard.enableMove(false, false); } catch(e) {}
        try { window.griddashboard.enableResize(false, false); } catch(e) {}
      } else {
        window.griddashboard.column(12);
        try { window.griddashboard.enableMove(true, true); } catch(e) {}
        try { window.griddashboard.enableResize(true, true); } catch(e) {}
      }
    } catch (e) {
      // ignore
    }
  }
  applyResponsiveGridColumns();
  window.addEventListener('resize', applyResponsiveGridColumns);
  window.addEventListener('orientationchange', applyResponsiveGridColumns);
  // var observer = new MutationObserver(function (mutations) {
  //   mutations.forEach(function (mutation) {
  //     if (mutation.attributeName === 'style') {
  //       resizeAllPlotlyGraphs();
  //     }
  //   });
  // });
  // observer.observe(document.querySelector('.grid-stack-item'), {
  //   attributes: true,
  //   attributeFilter: ['style']
  // });
  // griddashboard.onResizeHandler = function (event, items) {
  //
  //   _.each(items, function (item) {
  //     var plotly = $(item.el).find('.js-plotly-plot');
  //     if (plotly.length) {
  //       Plotly.Plots.resize(plotly[0]);
  //     }
  //   });
  // }
  // griddashboard.on('change', function (event, items) {
  //   items.forEach(function (item) {
  //     var graph = item.el.querySelector('.js-plotly-plot');
  //     if (graph) {
  //       Plotly.Plots.resize(graph);
  //     }
  //   });
  // });

  //listen to resizes or additions
  var $grid = $('.grid-stack');
  var timeoutId = null;
  saveConfig = function (event, items) {
    //save once
    let timeout = window.setTimeout(function () {
      var currentConfig = getGridConfigNoHTML();
      dataAccessor.saveGridConfigForCurrentDashboard(userData, currentConfig);
      //todo also save a full version to a cache locally not firebase
      timeoutId = null;
      // saveGridConfig(currentConfig);
    }, 2000);
    if (timeoutId) {
      window.clearTimeout(timeoutId);
    }
    timeoutId = timeout;
  };
  $grid.on('added', saveConfig); // this would trigger lots of saving on render but its debounced - it overrides the layout if someone else is working simultaneously
  $grid.on('resizestop', saveConfig);
  $grid.on('dragstop', saveConfig);
  return window.griddashboard || null;
}

if (!globalThis.IS_TEST_ENV && typeof document !== 'undefined') {
  $(document).ready(initializeGridDashboard);
}

export { initializeGridDashboard };
